import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import React from "react";

const RedemptionHeader: React.FC = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" flexDirection="column" gap="4px">
        <Typography variant="headlineSmall" component="h1">
          Redemptions
        </Typography>
        <Typography variant="bodyMedium" fontWeight={600} color="textSecondary">
          PRET POINTS
        </Typography>
      </Box>
      <Box display="flex" gap="0.5rem">
        <Tooltip title="Redemptions">
          <Avatar
            sx={{
              backgroundColor: "black",
              width: "48px",
              height: "48px",
            }}
          >
            <img
              style={{ maxHeight: "96px", maxWidth: "100%" }}
              src="/assets/icons/AiOutlineSchedule.svg"
              alt="Redemptions"
            />
          </Avatar>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default RedemptionHeader;
